import breakpointMediaQueries, { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import { TYPOGRAPHY } from "@store/theme/design";
import { polyfillCss } from "@store/theme/polyfills";
import { css } from "styled-components";

export default {
    defaultProps: {
        currentPageButtonVariant: "outline",
        selectProps: {
            cssOverrides: {
                formField: css`
                    font-size: ${TYPOGRAPHY.size.tiny};
                    width: auto !important;
                    text-align: center;
                `,
                formInputWrapper: css`
                    display: inline-block;
                    width: auto;
                    select {
                        height: 22px !important;
                        padding: 0 14px 0 6px !important;
                        font-size: ${TYPOGRAPHY.size.tiny} !important;
                    }
                `,
            },
            labelProps: {
                css: css`
                    padding-top: 1.5px;
                    padding-right: 5px;
                    font-size: ${TYPOGRAPHY.size.tiny};
                    width: auto;
                `,
            },
            iconProps: {
                size: 12,
                css: css`
                    width: ${TYPOGRAPHY.size.tiny} !important;
                    height: 18px !important;
                    padding: 0 !important;
                `,
            },
        },
        cssOverrides: {
            perPageSelect: polyfillCss`
                text-align: center;
                display: block;
                ${({ theme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                display: block;
                            `,
                            null,
                            css`
                                display: block;
                            `,
                            null,
                            null,
                        ],
                        "max",
                    )};

            `,
            pagination: css`
                flex-direction: column-reverse;
                justify-content: center;
            `,
            currentButton: polyfillCss`
                border: 0;

                &:not(:disabled):hover {
                    background: transparent;
                }

                span {
                    font-weight: ${TYPOGRAPHY.weight.bold};
                }
            `,
        },
    },
};
